import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { initI18n, initSentry, setRestApiUrl, SettingsLoader } from '@loyalup/core';

import 'normalize.css';
import '@loyalup/ui/build/styles.css';

import Routes from 'routes';
import { SuspenseLoader } from '@loyalup/ui';
import resources from '@loyalup/locales';

setRestApiUrl(process.env.REACT_APP_SERVER_URL);
initSentry(process.env.REACT_APP_SENTRY_DSN, process.env.REACT_APP_RELEASE_NAME, process.env.REACT_APP_ENV);

const App = () => {
  const i18n = initI18n(resources);

  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<SuspenseLoader />}>
        <SettingsLoader>
          <Routes />
        </SettingsLoader>
      </Suspense>
    </I18nextProvider>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
